import { useRefillsStore } from '../../../stores/useRefillsStore';
import { RefillItemRow, RefillItemCard } from './RefillItem';
import type { Refill } from '../../../stores/types';

export interface RefillsListProps {
  view: 'List' | 'Grid';
  onShowDetail: (rx: string) => void;
}

export function RefillsList({ view, onShowDetail }: RefillsListProps) {
  const { refills, loading, noScripts, toggleScript, selectAll } = useRefillsStore();

  const allSelectable = refills.filter(r => r.canSelect);
  const allSelected = allSelectable.length > 0 && allSelectable.every(r => r.selected);

  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    selectAll(e.target.checked);
  };

  const handleToggle = (refill: Refill) => {
    if (refill.canSelect) {
      toggleScript(refill);
    }
  };

  if (loading) {
    return (
      <div>
        <div className="spinner large">
          <div className="rect1" />
          {' '}
          <div className="rect2" />
          {' '}
          <div className="rect3" />
          {' '}
          <div className="rect4" />
          {' '}
          <div className="rect5" />
          <h4>Loading Prescriptions</h4>
        </div>
      </div>
    );
  }

  if (noScripts) {
    return (
      <div className="animate-show">
        <div className="noscripts animate-show">
          <h3>No Prescriptions Found</h3>
        </div>
      </div>
    );
  }

  if (view === 'List') {
    return (
      <div className="panel-body">
        <div id="tableContainer" className="tableContainer">
          <table
            className="refill-table table-striped"
            id="refills"
            cellPadding={0}
            cellSpacing={0}
          >
            <thead className="fixedHeader" id="fixedHeader">
              <tr>
                <th style={{ textAlign: 'center', width: 65 }}>
                  Select to Fill
                  <br />
                  <input type="checkbox" checked={allSelected} onChange={handleSelectAll} />
                </th>
                <th style={{ width: 150 }}>Rx#</th>
                <th>Name</th>
                <th style={{ textAlign: 'right', width: 150 }}>Quantity</th>
                <th style={{ textAlign: 'right', width: 150 }}>Days Supply</th>
                <th style={{ textAlign: 'center' }}>Next Refill</th>
                <th style={{ width: 50 }}>Refills Remaining</th>
                <th style={{ width: 340 }}>Status</th>
              </tr>
            </thead>
            <tbody className="scrollContent">
              {refills.map(refill => (
                <RefillItemRow
                  key={refill.rx}
                  refill={refill}
                  onToggle={handleToggle}
                  onShowDetail={onShowDetail}
                />
              ))}
            </tbody>
          </table>
        </div>
        <h6 style={{ fontStyle: 'italic' }}>
          * Order totals are estimated using previous copay amounts and may not reflect actual cost
          when processed.
        </h6>
      </div>
    );
  }

  // Grid view
  return (
    <div className="panel-body pre-scrollable" style={{ maxHeight: '380px !important' }}>
      <div className="row" style={{ padding: 5 }}>
        {refills.map(refill => (
          <RefillItemCard
            key={refill.rx}
            refill={refill}
            onToggle={handleToggle}
            onShowDetail={onShowDetail}
          />
        ))}
      </div>
      <h6 style={{ fontStyle: 'italic' }}>
        Order totals are estimated using previous copay amounts and may not reflect actual cost when
        processed.
      </h6>
    </div>
  );
}
